<template>
  <div>
    <div class="nav-pagination">
      <div class="container">
        <hr class="hraing" />
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="sooper-text">
              <h4>Machine Learning Consulting & Development</h4>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 text-right nav-pagination1">
            <ul>
              <li>
                <a href="index.html">Services</a>
              </li>
              <li>|</li>
              <li>Machine Learning</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <section class="discover-analytics">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="right-text wow animated slideInLeft">
              <h1>Machine Learning Consulting & Development</h1>
              <h4>Leverage your data with cutting edge technology</h4>
              <p>If you don't know where to start with leveraging Machine Learning, we can help. We design, build and manage Machine Learning models built around your organisation's needs.</p>
              <div class="button-center">
                <router-link to="/Contact">
                  <a class="btn button3">Get Started</a>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="wow animated zoomIn">
              <img
                src="../image/Vectors/inspiration-ideaDAC.svg"
                class="img-responsive img-services-vector"
                alt="desktop"
              />
            </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <div class="wow animated zoomIn">
              <br />
              <br />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div class="wow animated zoomIn">
              <center>
                <img
                  src="../image/Icons/Checklist.png"
                  class="img-responsive img-service-page"
                  alt="desktop"
                />
              </center>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right-text wow animated slideInLeft">
              <h4>Understand the complex landscape</h4>
              <p>We help you choose the right tools for your needs, from customisable frameworks to ground up development.</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wow animated zoomIn">
              <center>
                <img
                  src="../image/Icons/Dash showing percentage.png"
                  class="img-responsive img-service-page"
                  alt="desktop"
                />
              </center>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right-text wow animated slideInLeft">
              <h4>Stress free implementation</h4>
              <p>We assist you in understanding what’s going on under the hood, as well as maintaining models so they don't lose accuracy when put into production.</p>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <br />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInLeft">
                <div class="img-nn"></div>
                <h4>Neural Networks</h4>
                <p>Create cutting edge solutions to complex problems.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInUp">
                <div class="img-fr"></div>
                <h4>Feature Reduction</h4>
                <p>Gain deep understanding of the importance of different features.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInRight">
                <div class="img-nlp"></div>
                <h4>Natural Language Processing</h4>
                <p>Unlock text data with tools like sentiment analysis and translation.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInLeft">
                <div class="img-kpi"></div>
                <h4>Predictive Models</h4>
                <p>Use historic data to predict the outcomes of real time events.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>

          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInUp">
                <div class="img-class"></div>
                <h4>Document Classification</h4>
                <p>Automate processes by letting machine learning handle decisions.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>

          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInRight">
                <div class="img-perf"></div>
                <h4>Model Performance Analysis</h4>
                <p>Track and evaluate the performance of Machine Learning models.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-12 no-padding">
            <div class="heading text-center">
              <br />
              <h3>What our customers think about</h3>
              <br />
              <h3>Discovr Analytics</h3>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">

              <div class="quest-text1 wow animated slideInLeft">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >The Discovr team has been a great pleasure to work with - always responsive to my many queries and requests, as well as coming up with realistic suggestions on how we analyse/visualise our data.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/ResetHealthLogo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Dr Ling C | Head of Operations, Reset Health</a>
                </h5>

              </div>

          </div>
          <div class="col-md-4 col-sm-12">
            <router-link
              to="/Case-Study/Machine%20Learning%20for%20WorkPlace%20Buzz?post_id=439vIex7RTKByrUfH5v3H0"
            >
              <div class="quest-text1 wow animated slideInUp">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >Discovr Analytics has helped us to modernise our Engagement Survey Product's infrastructure allowing us to gain much more valuable insights for us and our customers.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/WPB-logo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Mark S PhD | Chief Psychologist, WorkplaceBuzz</a>
                </h5>
                <a>
                  <br />Read Case Study
                </a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-12">
            <router-link
              to="/Case-Study/eDNA%20OTA%20and%20Meta%20Analysis%20for%20EasyJet?post_id=5Yix0Lb8ZNtYcIIPvWNHKd"
            >
              <div class="quest-text1 wow animated slideInRight">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >Discovr Analytics helped us develop and manage intuitive analytics for our customers - all hosted in their easy to use white-label business intelligence platform.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/edna-logo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Jon S | Founder and Director, eDNA Solutions</a>
                </h5>
                <a>
                  <br />Read Case Study
                </a>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Machine Learning",
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Tailored Machine Learning Consulting & Development; We design and develop analytics for small to medium sized business and enterprise clients using tools like Tensorflow, Python and Azure Machine Learning Studio."
      }
    ],
    htmlAttrs: {
      lang: "en"
    },
    title: "Discovr Analytics | Analytics Consulting & Development Company",
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  data: function() {
    return {
      scrolled: true
    };
  },
  beforeDestroy() {
    window.analytics.page("Machine Learning");
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
